import { useId, useState } from "react";
import { Button } from "@/components/ui/button";
import { learnerChoicesForPlan, type LearnerChoice } from "@/lib/learners/whoIsLearning";

type Props = { maxLearners: number; onSubmit: (choice: LearnerChoice) => void };

const WhoWillBeLearningStep = ({ maxLearners, onSubmit }: Props) => {
  const [choice, setChoice] = useState<LearnerChoice | null>(null);
  const [error, setError] = useState<string | null>(null);
  const headingId = useId();
  const errorId = useId();
  const options = learnerChoicesForPlan(maxLearners);

  return (
    <form
      className="space-y-4"
      onSubmit={(e) => {
        e.preventDefault();
        if (!choice) {
          setError("Choose who will be learning to continue.");
          return;
        }
        onSubmit(choice);
      }}
    >
      <h2 id={headingId} className="font-heading text-xl font-bold text-foreground">Who will be learning?</h2>
      <div
        role="radiogroup"
        aria-labelledby={headingId}
        aria-describedby={error ? errorId : undefined}
        className="space-y-2"
      >
        {options.map((o) => (
          <label
            key={o.value}
            className="flex cursor-pointer items-start gap-3 rounded-lg border border-border bg-card p-3 has-[:checked]:border-primary"
          >
            <input
              type="radio"
              name="who-is-learning"
              value={o.value}
              checked={choice === o.value}
              onChange={() => { setChoice(o.value); setError(null); }}
              className="mt-1"
            />
            <span>
              <span className="block font-medium text-foreground">{o.label}</span>
              <span className="block text-sm text-muted-foreground">{o.hint}</span>
            </span>
          </label>
        ))}
      </div>
      <p className="text-xs text-muted-foreground">You can manage learners later. Parent access never uses a learner seat.</p>
      {error && <p id={errorId} role="alert" className="text-sm text-destructive">{error}</p>}
      <Button type="submit" className="w-full">Continue</Button>
    </form>
  );
};

export default WhoWillBeLearningStep;
